import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=1708fa6c&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FaqItem: require('/home/lewis/actions-runner/_work/EchoWaveLunar/EchoWaveLunar/components/global/FaqItem.vue').default})
